export default class PriceEstimationForm {
    constructor() {
        this.form = document.querySelector('#price-estimation-form');
        this.formThankYou = document.querySelector('#price-estimation-form-thank-you');
        if (!this.form)
            return;
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.addEventListeners();
    }
    addEventListeners() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData = new FormData(this.form);
            this.submitForm(formData);
        });
    }
    submitForm(data) {
        const isValidForm = this.validateForm();
        if (!isValidForm) {
            console.log('Form is not valid');
            return;
        }
        this.form.classList.add('d-none');
        this.formThankYou.classList.remove('d-none');
        const formData = new FormData();
        data.forEach((value, key) => {
            formData.append(key, value);
        });
        const options = {
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            body: formData
        };
        fetch(window.localize_script.admin_ajax + '?action=submit_price_estimation_form', options)
            .then(response => response.json())
            .then((response) => {
        })
            .catch((error) => {
            console.error('Fetch error:', error);
        })
            .finally(() => {
            //
        });
    }
    validateForm() {
        let isValid = true;
        document.querySelectorAll('.error').forEach((error) => {
            error.classList.remove('error');
        });
        const requiredFields = this.form.querySelectorAll('[data-required]');
        requiredFields.forEach((field) => {
            if (field.value === '') {
                field.parentElement.classList.add('error');
                isValid = false;
            }
            if (field.getAttribute('type') === 'email') {
                const email = field;
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(email.value)) {
                    field.parentElement.classList.add('error');
                    isValid = false;
                }
            }
            if (field.getAttribute('type') === 'checkbox') {
                const checkbox = field;
                if (checkbox.checked === false) {
                    field.parentElement.classList.add('error');
                    isValid = false;
                }
            }
        });
        return isValid;
    }
}
